
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fsd",
      function () {
        return require("private-next-pages/fsd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fsd"])
      });
    }
  